const initialState = {
    isOpen: false,
    data: {},
};
const modalTransDetails = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_TRANS_DETAILS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalTransDetails;
